<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <b-container fluid>

            <b-row class="titulo">
                <b-col class="seccionTitulo">
                    <span class="fa fa-table"></span>
                    <span>Historial de citas</span>
                </b-col>
                <b-col class="seccionCodigo">
                    <div></div>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="subtitulos">
                    Citas
                </b-col>
                <b-col cols="12">
                    <b-table
                            id="citas"
                            class="tabla-citas"
                            thead-tr-class="columnas"
                            :items="citas"
                            :fields="columnas"
                            :per-page="registrosPorPagina"
                            :current-page="paginaActual"
                            responsive
                    >
                        <template v-slot:cell(idCita)="row">
                            <strong v-if="row.item.citaAdministrativa == true"
                                      v-b-popover.hover.auto=" 'Cita Clínica'"
                                       size="sm" >
                             <span style="color: #0d0d0d">{{ row.item.idCita }} </span>
                            </strong>
                          <b-button v-else
                                    v-b-popover.hover.auto=" 'Cita Administrativa'"
                                    size="sm" variant="outline-primary">
                            <span style="color: #0d0d0d">{{ row.item.idCita }} </span>
                          </b-button>
                        </template>
                      <template v-slot:cell(fecha)="row">
                            {{row.item.fecha }}
                        </template>
                        <template v-slot:cell(inicio)="row">
                            {{row.item.inicio | formatoHoraDeEntero}}
                        </template>
                        <template v-slot:cell(fin)="row">
                            {{row.item.fin | formatoHoraDeEntero}}
                        </template>
                        <template v-slot:cell(fechaAlta)="row">
                            {{row.item.fechaAlta | formatoFechaHora}}
                        </template>
                        <template v-slot:cell(Acciones)="row">
                            <b-button-group>
                                <b-button v-if="row.item.fechaCancelacion != null"
                                          v-b-popover.hover.auto="row.item.motivoCancelacion" :title="'Fecha de cancelacion: '+ $options.filters.formatoFecha(row.item.fechaCancelacion)"
                                        size="sm"
                                        variant="outline-danger"
                                ><em class="fa fa-calendar-times-o"></em></b-button>
                                <b-button v-if="row.item.observaciones !== null  && row.item.observaciones !== '' "
                                        size="sm"
                                        @click="mostrarComentarios(row.item.observaciones)"
                                        variant="outline-info"
                                ><em class="fa fa-comment"></em></b-button>
                            </b-button-group>

                        </template>
                    </b-table>
                    <div align="center" v-if="loader">
                        <b-spinner variant="primary" label="Spinning"></b-spinner>
                    </div>
                    <b-col v-if="!loader">
                        <b-alert v-if="citas.length === 0" variant="warning" show>No hay datos</b-alert>
                    </b-col>
                    <b-col v-if="!loader">
                        <b-pagination
                                v-if="citas !== undefined && citas.length > 10"
                                align="center"
                                v-model="paginaActual"
                                :total-rows="citas.length"
                                :per-page="registrosPorPagina"
                                aria-controls="my-table1"
                        ></b-pagination>
                    </b-col>
                </b-col>
            </b-row>
            <b-modal
            v-model="modalComentarios" hide-header-close hide-footer
            size="md"
            title="Comentarios de la cita">
            
            <div v-for="(comentario, index) in comentarios" :key="index">
                <div class="text-left mb-3">
                    <div class="d-flex">
                      <p class="mr-1" style="font-size: .7em; margin-bottom: 0px; color: #6E6E6E !important;">{{comentario.usuarioAlta}}</p>
                      <p style="font-size: .7em; margin-bottom: 0px; color: #6E6E6E !important;">{{comentario.fechaAlta | formatoFecha}}</p>
                    </div>
                    <div style="background-color: #F9F9F9; box-shadow: 0px 0px 1.5px 0px rgba(0, 0, 0, 0.32); min-height: 3em; padding: 2%; border-radius: 10px;">
                        <p style="font-size: .8em;">{{comentario.observacion}}</p>
                    </div>
                </div>
            </div>
            </b-modal>
        </b-container>
    </div>
</template>

<script>

    export default {
        name: "HistorialCirtas",
        props: {
            paciente:Number
        },
        data: () => {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,

                modalComentarios: false,
                citas: [],
                columnas: [
                    {key: "idCita", label: "ID", sortable: true},
                    {key: "fecha", label: "Próxima Cita", sortable: true},
                    {key: "canal", label: "Canal", sortable: true},
                    {key: "clinica", label: "Clínica", sortable: true},
                    {key: "empleado", label: "Doctor", sortable: true},
                    {key: "sillon", label: "Sillón", sortable: true},
                    {key: "duracion", label: "Duración", sortable: true},
                    {key: "inicio", label: "Hr Inicio", sortable: true},
                    {key: "fin", label: "Hr Fin", sortable: true},
                    {key: "tratamiento", label: "Tratamiento", sortable: true},
                    {key: "fechaAlta", label: "Fecha de Alta", sortable: true},
                    {key: "usuarioAlta", label: "Usuario de Alta", sortable: true},
                    {key: "nombreUsuarioModifico", label: "Última Modificación", sortable: true},
                    {key: "estatus", label: "Estatus", sortable: true},
                    "Acciones",
                ],
                registrosPorPagina: 10,
                paginaActual: 0,
                loader: false,
                filtro: {
                    fecha: null
                },
                comentarios: null
            }
        },
        created() {
          this.debug = this.$localStorageService.getDebug();

            this.buscarCitas();
        },
        methods:{
            mostrarComentarios(comentarios){
                this.comentarios = comentarios;
                this.modalComentarios = true;
            },
            buscarCitas(){
                this.loader = true
                this.citas = [];
                const parametros = {idPaciente: this.paciente}
                this.$http.post(this.$api + 'cita/citasPaciente', parametros).then(respuesta => {
                        if (respuesta.data.data){
                            this.citas = respuesta.data.data;

                            this.citas.forEach( c => {
                              let extraida = c.fecha.substring(0, 10);
                              c.fecha = extraida
                            })
                        }
                    }
                ).catch((error) =>{
                    console.error(error);
                }).finally(() => {
                        this.loader = false;
                    }
                )
            }
        }
    }
</script>

<style scoped>
    .tabla-citas{
        margin-top: 5px;
        font-size: 11px;
    }
</style>
